import React from "react";
import { Link } from "react-router-dom";
import Iframe from "react-iframe";

function Contactbanner() {
    return (
        <>
            <div className="contact-map">
                <Iframe
                    src="https://www.google.com/maps?q=Chez+Fran%C3%A7ois+Restaurant+and+Patio,1716+Bow+Valley+Trail,Canmore,+AB+T1W+2X3&hl=en&z=15&output=embed"
                    width="100%"
                    height="500"
                    style="border:0;"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></Iframe>
            </div>

            <section className="contact-page">
                <div className="location-center">
                    <div className="auto-container">
                        <div className="cinfo-box">
                            <div className="row clearfix">
                                <div className="contactinfo-block col-lg-4 col-md-4 col-sm-12">
                                    <div
                                        className="inner-box wow fadeInUp"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="300ms"
                                    >
                                        <h4>Breakfast Time</h4>
                                        <div className="text">
                                            {" "}
                                            Monday to Sunday <br /> 7.00 am -
                                            11.00am
                                        </div>
                                    </div>
                                </div>

                                <div className="contactinfo-block col-lg-4 col-md-4 col-sm-12">
                                    <div
                                        className="inner-box cp-seprator wow fadeInUp"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="300ms"
                                    >
                                        <h4>Catering & Wedding Menus</h4>

                                        <div className="link-box">
                                            <Link
                                                to="https://swyeat-events-storage.s3.ca-central-1.amazonaws.com/Wedding+Menu+Guide.pdf"
                                                className="theme-btn btn-style-two clearfix"
                                            >
                                                <span className="btn-wrap">
                                                    <span className="text-one">
                                                        menu guides
                                                    </span>
                                                    <span className="text-two">
                                                        menu guides
                                                    </span>
                                                </span>
                                            </Link>
                                        </div>
                                        <br />
                                        <div className="link-box">
                                            <Link
                                                to="https://swyeat-events-storage.s3.ca-central-1.amazonaws.com/Wedding+Menu+Guide.pdf"
                                                className="theme-btn btn-style-two clearfix"
                                            >
                                                <span className="btn-wrap">
                                                    <span className="text-one">
                                                        wedding menu
                                                    </span>
                                                    <span className="text-two">
                                                        wedding menu
                                                    </span>
                                                </span>
                                            </Link>
                                        </div>
                                        <br />
                                        <div className="text">
                                            Give us a call to start your
                                            planning!
                                        </div>
                                        <div className="more-link">
                                            <Link to="#">
                                                Booking : +1-403-678-6111
                                            </Link>
                                        </div>
                                        <li>
                                            <Link to="mailto:chezfrancoisbookings@gmail.com">
                                                chezfrancoisbookings@gmail.com
                                            </Link>
                                        </li>
                                    </div>
                                </div>

                                <div className="contactinfo-block col-lg-4 col-md-4 col-sm-12">
                                    <div
                                        className="inner-box wow fadeInUp"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="600ms"
                                    >
                                        <h4>lunch Time</h4>
                                        <div className="text">
                                            Monday to Friday
                                            <br />
                                            11.00 am - 2.30 pm
                                        </div>
                                        <br />
                                        <div className="text">
                                            Saturday & Sunday
                                            <br />
                                            11.00 am - 3.00 pm
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Contactbanner;
